import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  access: string | null;
  refresh: string | null;
  userId: string | null;
  tenantId: string | null;
  email: string | null;
  userName: string | null;
}

const initialState: AuthState = {
  access: null,
  refresh: null,
  userId: null,
  tenantId: null,
  email: null,
  userName: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setTokens(state, action: PayloadAction<{ access: string; refresh: string }>) {
      state.access = action.payload.access;
      state.refresh = action.payload.refresh;
    },
    setUser(state, action: PayloadAction<{ userId: string; tenantId: string; email: string; userName: string | null }>) {
      state.userId = action.payload.userId;
      state.tenantId = action.payload.tenantId;
      state.email = action.payload.email;
      state.userName = action.payload.userName;
    },
    logout(state) {
      state.access = null;
      state.refresh = null;
      state.userId = null;
      state.tenantId = null;
      state.email = null;
      state.userName = null;
    },
  },
});

export const { setTokens, setUser, logout } = authSlice.actions;
export const selectAuth = (state: { auth: AuthState }) => state.auth;
export default authSlice.reducer;
